if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();

      var self = this;

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');

      this.sendAsGiftButton = this.querySelector('[name="sendAsGift"]');
      this.sendAsGiftModal = document.querySelector("#SendAsGiftPopupModal");
      this.confirmSendAsGift = document.querySelector("#ConfirmSendAsGift");
      

      if(this.sendAsGiftButton && this.sendAsGiftModal && this.confirmSendAsGift) {
        this.form.addEventListener('submit', this.onGiftCardAddToCart.bind(this));
        this.sendAsGiftButton.addEventListener('click', this.sendAsGiftDialogShow.bind(this));
        this.confirmSendAsGift.addEventListener('click', this.confirmSendAsAGift.bind(this));
        this.emailInput = document.querySelector(`#Recipient-email`);
        this.nameInput = document.querySelector(`#Recipient-name`);
        this.messageInput = document.querySelector(`#Recipient-message`);
        this.sendonInput = document.querySelector(`#Recipient-send-on`);
        this.offsetProperty = document.querySelector(`#Recipient-timezone-offset`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();
        this.variantId = this.form.querySelector('[name=id]');
        //console.log('Date new', Intl.DateTimeFormat().resolvedOptions().timeZone);
        const picker = MCDatepicker.create({
            el: '#Recipient-send-on',
            dateFormat: 'MM/DD/YYYY',
            autoClose: true,
            minDate: new Date(),
            theme: {
                theme_color: '#00833e'
            }
        });
        this.sendonInput.addEventListener('click', () => {
          console.log('open picker');
        });
        document.body.addEventListener('modalClosed', () => {
          console.log('modalClosed');
          picker.close();
        });
      }
      else {
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }

      if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }


    resetGiftCardErrorMessages() {
      document.querySelector('#RecipientForm-email-error').classList.add('hidden');
    }
    
    validateGiftCardFields() {

      if(!this.emailInput.value || this.emailInput.value === "" || !String(this.emailInput.value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )) {
          document.querySelector('#RecipientForm-email-error').classList.remove('hidden');
          return false;
        }

      return true;
    }

    confirmSendAsAGift(evt) {
      console.log('test');

      this.resetGiftCardErrorMessages();
      if(this.validateGiftCardFields()) {

        /*let additionalFormData = [
          {key: 'properties[__shopify_send_gift_card_to_recipient]', value : 'true'},
          {key: 'properties[Recipient email]', value : this.emailInput.value},
          {key: 'properties[Recipient name]', value : this.nameInput.value},
          {key: 'properties[Message]', value : this.messageInput.value},
          {key: 'properties[Send on]', value : this.sendonInput.value},
          {key: 'properties[__shopify_offset]', value : this.offsetProperty.value},
        ];

        this.onSubmitHandler(evt, additionalFormData);*/
        GiftHeroAPI.setCardData({
          email: this.emailInput.value,
          from: this.nameInput.value,
          message: this.messageInput.value,
          variantId: this.variantId.value
        });

        if(this.sendonInput.value !== "") {
          GiftHeroAPI.setDeliveryDate(new Date(this.sendonInput.value));
        }
        else {
          GiftHeroAPI.setDeliveryDate(new Date());
        }

        let results = GiftHeroAPI.validate();
        console.log(results);
        if(results.valid) {
          GiftHeroAPI.addToCart().then((data, status) => {
            console.log('added');
            this.emailInput.value = '';
            this.nameInput.value = '';
            this.messageInput.value = '';
            this.sendonInput.value = '';
            this.sendAsGiftModal.hide();
            reloadCartDrawer();
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.cart.open();
            if(this.cart) {
              this.cart.focus();
            }
          });
        }

      }
    }

    sendAsGiftDialogShow(evt) {
      this.resetGiftCardErrorMessages();
      this.sendAsGiftModal.show(this.sendAsGiftButton);
    }

    onGiftCardAddToCart(evt, additionalFormData) {
      evt.preventDefault();
      console.log('onGiftCardAddToCart');
        GiftHeroAPI.setCardData({
          variantId: this.variantId.value
        });
        let results = GiftHeroAPI.validate();
        console.log(results);
        if(results.valid) {
          GiftHeroAPI.addToCart().then((data, status) => {
            console.log('added');
            this.emailInput.value = '';
            this.nameInput.value = '';
            this.messageInput.value = '';
            this.sendonInput.value = '';
            this.sendAsGiftModal.hide();
            reloadCartDrawer();
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            this.cart.open();
            if(this.cart) {
              this.cart.focus();
            }
          });
        }
    }

    onSubmitHandler(evt, additionalFormData) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if(additionalFormData) {
        for(var i = 0; i < additionalFormData.length; i++) {
          formData.append(additionalFormData[i].key, additionalFormData[i].value);
        }
      }

      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');

          if(this.cart) {
            this.cart.focus();
          }
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  };
  customElements.define('product-form', ProductForm)

  class StickyAddToCart extends ProductForm {
    constructor() {
      super();
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.pdpCta = document.querySelector('.product-form__buy-buttons');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      window.addEventListener('scroll', this.displayElementOnScroll.bind(this));
    }    

    displayElementOnScroll() {
      const buyButtonPos = this.pdpCta.offsetTop + this.pdpCta.offsetHeight;
      if (buyButtonPos > window.scrollY) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    }
  };
  customElements.define('sticky-add-to-cart', StickyAddToCart)
}
